import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M4 4a16 16 0 0 1 16 16","key":"svg-1"}],["path",{"d":"M4 11a9 9 0 0 1 9 9","key":"svg-2"}]]

/**
 * IconRss
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcnNzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDE5YTEgMSAwIDEgMCAyIDBhMSAxIDAgMSAwIC0yIDAiIC8+CiAgPHBhdGggZD0iTTQgNGExNiAxNiAwIDAgMSAxNiAxNiIgLz4KICA8cGF0aCBkPSJNNCAxMWE5IDkgMCAwIDEgOSA5IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/rss
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconRss = createReactComponent('outline', 'rss', 'Rss', __iconNode);

export default IconRss;